<app-map
  [mapInitialized]="_mapInitialized"
  [hasErrorLoadingMap]="_errLoadingMap"
/>
